import { WelcomeComponent } from "@/components";

export default {
  name: "Home",
  components: {
    WelcomeComponent,
  },
  setup(props) {},
};
